module.exports = __webpack_public_path__ + "img/frame (27).e120c6e7.jpg";